import { useSyncExternalStore } from 'react';

import { DEFAULT_READER, readPreferences, type ReaderPreferences } from './readerPreferencesModel';
export * from './readerPreferencesModel';
import { settingsCache, setSettingsIdentity, updateSettings, subscribeSettings } from '@/lib/settings/cache';

function snapshot() {
  const v = settingsCache.value;
  return readPreferences(JSON.stringify({ appearance: v.appearance, accent: v.accent,
    railSide: v.rail_side, menu: v.menu, typeScale: v.type_scale, contentScale: v.content_scale }));
}
let current = snapshot();
subscribeSettings(() => { current = snapshot(); apply(); });

function apply() {
  const root = document.documentElement;
  root.dataset.appearance = current.appearance;
  root.dataset.accent = current.accent;
  root.dataset.railSide = current.railSide;
  root.dataset.menu = current.menu;
  root.style.setProperty('--type-scale', String(current.typeScale));
  root.style.setProperty('--content-scale', String(current.contentScale));
}
export function updateReaderPreferences(patch: Partial<ReaderPreferences>) {
  const next = readPreferences(JSON.stringify({ ...current, ...patch }));
  const mapping = { appearance: 'appearance', accent: 'accent', railSide: 'rail_side',
    menu: 'menu', typeScale: 'type_scale', contentScale: 'content_scale' } as const;
  updateSettings(Object.fromEntries((Object.keys(patch) as (keyof ReaderPreferences)[])
    .map(key => [mapping[key], next[key]])));
}
export function useReaderPreferences() {
  return useSyncExternalStore(subscribeSettings, () => current, () => DEFAULT_READER);
}

/** Apply the cached appearance before the first paint. */
export function initializeReaderPreferences() {
  apply();
  window.addEventListener('storage', () => setSettingsIdentity(settingsCache.subject));
}
export function setReaderIdentity(subject?: string) {
  setSettingsIdentity(subject);
}
